import { TooltipTrigger } from "@visiblethread/react-components";
import Flex, { GAP_CLASS } from "components/Flex";
import { toTitleCase } from "utils/string";

import RequirementChip from "../RequirementChip";
import AddressedInCell from "./AddressedInCell";
import styles from "./CoverageRequirementsTable.module.scss";

const ADDRESSED_IN_COLUMN = {
  header: "Addressed In",
  id: "addressedIn",
  accessorKey: "addressedIn",
  size: 130,
  cell: ({ row, getValue }) => (
    <AddressedInCell
      paragraphRowIndex={row.index}
      paragraphRow={row.original}
      value={getValue()}
    />
  ),
};

export default ({ showAddressedIn }) => {
  const columns = [
    {
      enableSorting: false,
      header: "Page",
      accessorKey: "page",
      id: "page",
      minSize: 80,
      size: 80,
      meta: {
        flexGrow: 0,
      },
      cell: (c) => c.getValue() ?? "—",
    },
    {
      header: "Content",
      enableSorting: false,
      id: "content",
      cell: ({ row }) => {
        const { original } = row;
        const { categories = [], refs = [] } = original;
        const parsedCategories = categories.reduce((arr, cat) => {
          const split = cat.split("|").filter(Boolean);
          return arr.concat(split);
        }, []);
        const hasChips = refs?.length > 0 || parsedCategories?.length > 0;

        return (
          <span className={styles.cell} role="cell">
            {hasChips && (
              <Flex className={styles.chips} gap={GAP_CLASS.GAP_150}>
                {(refs || []).map((ref) => (
                  <RequirementChip key={ref} value={ref} />
                ))}

                {(parsedCategories || []).map((category) => (
                  <TooltipTrigger
                    classes={styles.tooltip}
                    content={`Requirement Type: ${toTitleCase(category)}`}
                    key={category}
                    delay={1000}
                  >
                    <RequirementChip value={toTitleCase(category)} />
                  </TooltipTrigger>
                ))}
              </Flex>
            )}

            <span
              title={
                original.restatement
                  ? `Extracted as: ${original.restatement}`
                  : undefined
              }
            >
              {original.text}
            </span>
          </span>
        );
      },
    },
  ];

  if (showAddressedIn) {
    columns.push(ADDRESSED_IN_COLUMN);
  }

  return columns;
};
